import React, { forwardRef } from 'react'
import { FieldValues, useController, UseControllerProps } from 'react-hook-form'

export type TextAreaProps = {
  minHeight?: string
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ minHeight = '4em', ...props }, ref) => (
    <textarea
      ref={ref}
      style={{ minHeight }}
      className="flex-grow p-2 font-light w-auto border-contentareaborder border rounded"
      {...props}
    />
  )
)

TextArea.displayName = 'TextArea'
export type TextAreaFieldProps = {
  name: string
  minHeight?: string
} & UseControllerProps<FieldValues> &
  React.TextareaHTMLAttributes<HTMLTextAreaElement>

export const TextAreaField: React.FC<TextAreaFieldProps> = ({
  name,
  control,
  defaultValue = '',
  minHeight,
  ...rest
}) => {
  const {
    field: { onChange, onBlur, value, ref },
  } = useController({
    name,
    control,
    defaultValue,
  })

  return (
    <TextArea
      {...rest}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      ref={ref}
      minHeight={minHeight}
    />
  )
}
